import { useHotels } from "contexts/HotelsSearchContext/HotelProvider";
import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LocalStorageRecentSearches } from "./LocationInput";

interface Props {
  className?: string;
  href: string;
}

const ButtonSubmit: FC<Props> = ({
  className = "",
  href = "/listing-stay-map",
}) => {
  const {
    destination,
    checkInDate,
    numNights,
    guests,
    setSubmitSearchHotels,
    setShowHeroSearch,
    setLoading,
    setDestinationName,
    searchHotels,
    setPageReload,
    setHotels,
    getHotelSearchFirst,
    setHotelSearchFirst,
    setHiddenHero,
    setSearchEngine,
  } = useHotels();
  const navigate = useNavigate();
  const location = useLocation();

  const storedDestinationsString = localStorage.getItem(
    "recentSearchesDestinations"
  );
  const storedDestinations: LocalStorageRecentSearches[] = storedDestinationsString
    ? JSON.parse(storedDestinationsString)
    : [];

  const handleSubmitSearchHotels = () => {
    if (destination && checkInDate && numNights && guests) {
      setSearchEngine(true);
      setHiddenHero(false);
      setLoading(true);
      setDestinationName("");
      setSubmitSearchHotels(true);
      setShowHeroSearch(null);
      if (location.pathname !== "/home") {
        navigate("/home", { replace: true });
      } else {
        setHotels([]);
        searchHotels({
          destination,
          numNights,
          checkInDate,
          guests,
        }).finally(() => {
          setPageReload(true);
          const hotelSearchFirst = storedDestinations.find(
            (item) => item.type === "HOTEL"
          );
          if (hotelSearchFirst) {
            setHotelSearchFirst(getHotelSearchFirst);
          } else {
            setHotelSearchFirst(null);
          }
        });
      }
      (document.querySelector(".nc-Footer") as HTMLElement | null)?.click();
    }
  };

  return (
    <button
      type="button"
      className={`h-14 w-14 rounded-full bg-[--green] hover:bg-[--green-dark] transition-colors duration-300 ease-in-out flex items-center justify-center text-neutral-50 focus:outline-none ${className}`}
      onClick={handleSubmitSearchHotels}
    >
      <span className="mr-3 md:hidden">Buscar</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </button>
  );
};

export default ButtonSubmit;
